// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TLV6n","field":"styles_field__2GwIZ","fieldCol":"styles_fieldCol__15jat","diffCol":"styles_diffCol__2Q6cn","diff":"styles_diff__2nKEB"};